module.exports = __webpack_public_path__ + "static/media/mail.c2fc42e2.png";